import React from 'react';
import styled from '@emotion/styled';
import { Skeleton } from '@mui/material';
import breakpoints from '../Theme/breakpoints';

const NewsFeed = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: calc(100%);
  padding-top: 1.5rem;

  @media (min-width: ${breakpoints.md}px) {
    flex-wrap: wrap;
    flex-direction: row;
  }
`;

const NewsFeedItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  width: 100%;
  height: 167px;
  margin-bottom: 1rem;
`;

const NewsFeedItemImage = styled(Skeleton)`
  height: 86px;
  width: 130px;

  @media (min-width: ${breakpoints.xssm}px) {
    height: 134px;
    width: 201px;
  }
`;

const NewsFeedItemContent = styled(Skeleton)`
  flex: 1;
  height: 100%;
  margin-right: .5rem;
`;

const NewsFeedItem = () => (
  <NewsFeedItemContainer>
    <NewsFeedItemContent variant="rectangular" />
    <NewsFeedItemImage variant="rectangular" />
  </NewsFeedItemContainer>
);

const StyledNewsFeedItem = styled(NewsFeedItem)`
  height: 200px;
`;

const NewsFeedSkeletonLoader = () => (

  <NewsFeed>
    <StyledNewsFeedItem />
    <StyledNewsFeedItem />
    <StyledNewsFeedItem />
  </NewsFeed>

);

export default NewsFeedSkeletonLoader;
